import React, { useRef, useState } from "react";
import IntlTelInput from "react-intl-tel-input";
import PropTypes from "prop-types";
import useLanguageChange from "../../../../hooks/useLanguageChange";
import {
    allowedCountries,
    allowedCountriesDialCodePattern,
    DEFAULT_COUNTRY_CODE,
    INVITE_TYPE,
    PHONE_NUMBER_REGEX,
} from "../../../../constants/InviteConstants";
import { setSelectedSmsCountry, setSelectedWhatsAppCountry } from "../../../../reducers/invite-reducer";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { PREFERRED_COUNTRIES_LIST, UK_COUNTRY_CODE_NEW, UK_COUNTRY_DIALCODE } from "../../../../constants/LanguageConstants";
import { PublicVariables } from "../../../../constants/PublicVariables";

const SendSMSAndWhatsApp = (props) => {
    const {
        type,
        id,
        testId,
        mobileNumberRef,
        defaultCountryCode,
        smsTemplate,
        whatsAppTemplate,
        whatsAppInviteUrl,
        isSentBtnVisible,
        handleCloseModal,
        isDoneBtnVisible,
        handleSendInvite,
        selectedCountry,
    } = props;

    const dispatch = useDispatch();
    const intlTelInputRef = useRef(null);
    const localisedValues = useLanguageChange();

    const { inviteParticipantLoading } = useSelector((state) => state.onLoadData);

    const [mobileNumber, setMobileNumber] = useState(mobileNumberRef.current);
    const [isMobileNumberValid, setIsMobileNumberValid] = useState(true);
    const [isMobileNumberFieldFocused, setIsMobileNumberFieldFocused] = useState(false);

    const handleOnMobileNumberChange = (_isValid, value, countryData) => {
        const isValidPhoneNumber = intlTelInputRef.current?.isValidNumber(value);
        if (isValidPhoneNumber) {
            if (type === INVITE_TYPE.SMS) {
                dispatch(setSelectedSmsCountry(countryData));
            } else {
                dispatch(setSelectedWhatsAppCountry(countryData));
            }
            const numberInput = document.getElementById("numberInput");
            numberInput?.addEventListener("keyup", (event) => {
                if (event.key === "Enter") {
                    const actionButton = document.getElementById("sendInvitationBtn");
                    if (actionButton) actionButton.click();
                }
            });
        }

        let numberValue = value;
        let isNotValid = PHONE_NUMBER_REGEX.test(numberValue);

        // it ignores a-z characters
        if (isNotValid) {
            numberValue = numberValue?.replace(PHONE_NUMBER_REGEX, "");
        }

        let matchedCountryCode = numberValue.match(allowedCountriesDialCodePattern);

        // it converts +91 country codes values to india country and remove it from mobileNumber value
        if (matchedCountryCode && matchedCountryCode.length > 0) {
            const newValueIndex = numberValue.lastIndexOf("+");
            numberValue = numberValue.substring(newValueIndex);
            matchedCountryCode = numberValue.match(allowedCountriesDialCodePattern);
            numberValue = numberValue.substring(matchedCountryCode[0]?.length);
        }

        setIsMobileNumberValid(isValidPhoneNumber);
        mobileNumberRef.current = numberValue;
        setMobileNumber(numberValue);
        if (type === INVITE_TYPE.SMS) {
            dispatch(setSelectedSmsCountry(countryData));
        } else {
            dispatch(setSelectedWhatsAppCountry(countryData));
        }
    };

    const handleOnCountryChange = (_currentNumber, countryData) => {
        if (type === INVITE_TYPE.SMS) {
            dispatch(setSelectedSmsCountry(countryData));
        } else {
            dispatch(setSelectedWhatsAppCountry(countryData));
        }
    };

    const handleOnMobileNumberBlur = () => {
        setIsMobileNumberFieldFocused(false);
    };

    const handleOnMobileNumberFocus = () => {
        setIsMobileNumberFieldFocused(true);
    };

    const handleGenratePayload = () => {
        let countryIsoCode = selectedCountry.iso2 === UK_COUNTRY_DIALCODE ? UK_COUNTRY_CODE_NEW : selectedCountry.iso2;
        countryIsoCode = countryIsoCode.toUpperCase();

        const payload = {
            invitationType: type,
            countryCode: selectedCountry.dialCode,
            isoCode: countryIsoCode,
            mobileNo: mobileNumber.replace(/\D+/g, ""),
            message: smsTemplate,
        };
        handleSendInvite(payload);
    };

    return (
        <div className='tab-pane active' id={id} role='tabpanel' aria-labelledby={testId} data-testid={testId}>
            <div className='invite-participant'>
                <div className='invite-participant-box'>
                    <div className='invite-title-mobile'>
                        <h3>{type === INVITE_TYPE.SMS ? localisedValues.sms_label : localisedValues.whatsapp_label}</h3>
                    </div>
                    <div className='invite-title-desktop'>
                        <h3>{localisedValues.enter_mobile_number_lable}</h3>
                    </div>
                    <div className='invite-participant-form'>
                        <div className='form-group mobile-number-group'>
                            <div className='form-group-in'>
                                <IntlTelInput
                                    ref={intlTelInputRef}
                                    fieldId='numberInput'
                                    data-testId='numberInput'
                                    defaultCountry={defaultCountryCode || DEFAULT_COUNTRY_CODE}
                                    autoFocus={true}
                                    preferredCountries={PREFERRED_COUNTRIES_LIST}
                                    value={mobileNumber}
                                    containerClassName='intl-tel-input'
                                    inputClassName={`form-control dark-form-control height-46 ${PublicVariables.isIOSDevice ? "ios-font-size" : ""}`}
                                    separateDialCode={true}
                                    onlyCountries={allowedCountries}
                                    autoHideDialCode={true}
                                    placeholder={localisedValues.mobile_number}
                                    onPhoneNumberChange={handleOnMobileNumberChange}
                                    onPhoneNumberBlur={handleOnMobileNumberBlur}
                                    onPhoneNumberFocus={handleOnMobileNumberFocus}
                                    onSelectFlag={handleOnCountryChange}
                                    useMobileFullscreenDropdown={false}
                                />
                            </div>
                            {!isMobileNumberValid && !isMobileNumberFieldFocused && !isEmpty(mobileNumber) && (
                                <div className='validation-error'>{localisedValues.enter_valid_mobile}</div>
                            )}
                        </div>
                        {type === INVITE_TYPE.SMS && (
                            <div className='form-group sms-invite-textarea'>
                                <div className='form-group-in'>
                                    <textarea
                                        className='form-control dark-form-control form-control-grey focus-font-bold'
                                        disabled
                                        value={smsTemplate}
                                        style={{ fontSize: PublicVariables.isIOSDevice ? "16px" : "" }}
                                    />
                                </div>
                            </div>
                        )}
                        {type === INVITE_TYPE.WhatsApp && (
                            <div className='form-group'>
                                <div className='email-invitation-msg'>
                                    <div className='email-invitation-bar'>{whatsAppTemplate}</div>
                                    <div className='email-invitation-bar'>
                                        <a className='text-dec-none' href={whatsAppInviteUrl} target='_blank'>
                                            {whatsAppInviteUrl}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    {isSentBtnVisible && (
                        <div className='send-success'>
                            <span className='for-icon icon-checked-fill-bold'></span>
                            <span className='for-text'>
                                {type === INVITE_TYPE.SMS ? localisedValues.sms_sent_label : localisedValues?.whatsapp_sent_label}
                            </span>
                        </div>
                    )}
                </div>
                <div className='invite-participant-footer'>
                    <div className='button-inline more-space d-flex justify-content-end align-items-center'>
                        {isDoneBtnVisible && (
                            <div className='button' data-testid='doneBtn'>
                                <button type='button' className='btn btn-link default-btn-link' onClick={handleCloseModal}>
                                    {localisedValues.done}
                                </button>
                            </div>
                        )}
                        <div className='button'>
                            <button
                                type='button'
                                id='sendInvitationBtn'
                                className='btn btn-primary btn-with-icon default-btn-primary'
                                data-testid='sendInvitationBtn'
                                onClick={handleGenratePayload}
                                disabled={!isMobileNumberValid || isEmpty(mobileNumber) || inviteParticipantLoading}
                            >
                                {inviteParticipantLoading && (
                                    <span className='btn-loader-icon'>
                                        <span className='for-icon icon-loader spin'></span>
                                    </span>
                                )}
                                {localisedValues.send_invitaion_lable}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

SendSMSAndWhatsApp.propTypes = {
    type: PropTypes.any,
    id: PropTypes.string,
    testId: PropTypes.string,
    smsTemplate: PropTypes.any,
    whatsAppTemplate: PropTypes.any,
    whatsAppInviteUrl: PropTypes.any,
    defaultCountryCode: PropTypes.string,
    mobileNumberRef: PropTypes.any,
    selectedCountry: PropTypes.object,
    handleSendInvite: PropTypes.func,
    isDoneBtnVisible: PropTypes.bool,
    handleCloseModal: PropTypes.func,
    isSentBtnVisible: PropTypes.bool,
};

export default SendSMSAndWhatsApp;
